/* eslint-disable @typescript-eslint/promise-function-async */
export const nextTick = (): Promise<void> =>
  new Promise((resolve) => requestAnimationFrame(() => resolve()))
